import PropTypes from 'prop-types';
import Iconify from 'src/components/Iconify';
import { Input } from 'src/@/components/ui/input';
import { Separator } from 'src/@/components/ui/separator';
import { Button } from 'src/@/components/ui/button';
import { cn } from 'src/@/lib/utils';

DrawerNegocioNotasInput.propTypes = {
  disabled: PropTypes.bool,
  conversationId: PropTypes.string,
  onSend: PropTypes.func,
  changeText: PropTypes.func,
  text: PropTypes.string,
};

export default function DrawerNegocioNotasInput({ 
  disabled, 
  changeText, 
  text, 
  onSend, 
  className,
  ...other 
}) {
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (text?.trim()) {
        onSend?.();
      }
    }
  };

  return (
    <div 
      className={cn(
        "flex items-center gap-2 px-4 mt-4 border border-border rounded-md bg-background",
        className
      )}
      {...other}
    >
      <Input
        value={text || ''}
        onChange={(e) => changeText?.(e)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder="Escreva comentário..."
        className="flex-1 h-auto border-0 shadow-none bg-transparent focus-visible:ring-0"
      />
      
      <Separator orientation="vertical" className="h-8" />
      
      <Button 
        size="icon"
        className="h-6 w-6"
        variant="ghost"
        disabled={!text?.trim() || disabled}
        onClick={onSend}
      >
        <Iconify className="size-4" icon="mdi:send"/>
      </Button>
    </div>
  );
}
